import React, { useState } from 'react'
import { VFScreen } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import PropTypes from 'prop-types'

import Modal from '../../Components/Modal'

import CatalogueDetails from '../../Containers/CatalogueDetails'
import ConfirmationMenu from '../../Components/ConfirmationMenu'

import styles from './CatalogueDetailsScreen.Styles'
import { View, Dimensions, Platform, Pressable } from 'react-native'

import _Modal from '../../../../react-native-modal'

function CatalogueDetailsScreen({
  item,
  offerActivation,
  activate,
  resetOfferActivation,
  onBack,
  openPayments,
}) {
  const theme = useTheme()

  const { paymentMethods } = item

  const [confirmationMenu, setConfirmationMenu] = useState({
    isVisible: false,
    onHide: undefined,
  })

  const openConfirmationMenu = () => {
    setConfirmationMenu({ isVisible: true })
  }

  const closeConfirmationMenu = (callback) => {
    setConfirmationMenu({ isVisible: false, onHide: callback })
    resetOfferActivation()
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <VFScreen showBack title={item?.name} showClose={false} onBack={onBack} containerStyle={styles.container(theme)}>
        <CatalogueDetails
          {...item}
          onBack={onBack}
          onPressActionButton={openConfirmationMenu}
        />
        <_Modal
          isVisible={confirmationMenu.isVisible}
          close={closeConfirmationMenu}
          onBackdropPress={closeConfirmationMenu}
          contentContainerStyle={styles.quickActionMenuContainerStyle}
          onModalHide={() => {
            if (typeof confirmationMenu.onHide === 'function') {
              confirmationMenu.onHide()
            }
          }}
        >
          <View
            style={styles.modalView(theme)}
            onStartShouldSetResponder={() => true}>
            <ConfirmationMenu
              {...item}
              {...offerActivation}
              activate={activate}
              paymentMethods={paymentMethods}
              closeModal={closeConfirmationMenu}
              openPayments={openPayments}
              onBack={onBack}
            />
          </View>
        </_Modal>
      </VFScreen>
    )
  }

  return (
    <VFScreen withHeader={false} containerStyle={styles.container(theme)}>
      <CatalogueDetails
        {...item}
        onBack={onBack}
        onPressActionButton={openConfirmationMenu}
      />
      <Modal
        isVisible={confirmationMenu.isVisible}
        close={closeConfirmationMenu}
        onBackdropPress={closeConfirmationMenu}
        contentContainerStyle={styles.quickActionMenuContainerStyle(theme)}
        onModalHide={() => {
          if (typeof confirmationMenu.onHide === 'function') {
            confirmationMenu.onHide()
          }
        }}
      >
        <ConfirmationMenu
          {...item}
          {...offerActivation}
          activate={activate}
          paymentMethods={paymentMethods}
          closeModal={closeConfirmationMenu}
          openPayments={openPayments}
          onBack={onBack}
        />
      </Modal>
    </VFScreen>
  )
}
CatalogueDetailsScreen.defaultProps = {
  item: {},
  offerActivation: {},
  activate: () => { },
  onBack: () => { },
}
CatalogueDetailsScreen.propTypes = {
  item: PropTypes.object,
  offerActivation: PropTypes.object,
  activate: PropTypes.func,
  onBack: PropTypes.func,
  resetOfferActivation: PropTypes.func,
  openPayments: PropTypes.func,
}
export default CatalogueDetailsScreen
